<template>
  <CommonList
    selection-type="radio"
    row-key="id"
    :has-more-search="false"
    :auto-load="true"
    ref="listRef"
    cell-overflow="ellipsis"
    @selection-change="handleSelectionChange"
    @current-row-change="handleCurrentRowChange"
    @load-start="handleLoadList"
    @search-click="handleLoadList"
    @pagination-change="handleLoadList"
    @reset-click="handleReset"
  >
    <template #search-item-fixed>
      <div class="common-search-item">
        <label class="common-search-label80">活动名称:</label>
        <el-input v-model="searchForm.activityName" class="common-input150" placeholder="请输入"></el-input>
      </div>
      <div class="common-search-item">
        <label class="common-search-label80">状态:</label>
        <el-select v-model="searchForm.status" class="common-input120" placeholder="请选择" clearable>
          <el-option label="开启" value="1"></el-option>
          <el-option label="关闭" value="0"></el-option>
        </el-select>
      </div>
      <div class="common-search-item">
        <label class="common-search-label80">奖励类型:</label>
        <el-select v-model="searchForm.rewardType" class="common-input120" placeholder="请选择" clearable>
          <el-option label="积分" value="1"></el-option>
          <el-option label="物品" value="2"></el-option>
        </el-select>
      </div>
    </template>

    <template #btn-group>
      <el-button type="primary" class="list-btn" @click="handleAdd">
        <el-icon><Plus/></el-icon>
        新增
      </el-button>
      <el-button type="warning" class="list-btn" @click="handleEdit" :disabled="!listShow">
        <el-icon><Edit/></el-icon>
        修改
      </el-button>
      <el-button type="info" class="list-btn" @click="handleView" :disabled="!listShow">
        <el-icon><View/></el-icon>
        查看
      </el-button>
      <el-button type="danger" class="list-btn" @click="handleDelete" :disabled="!listShow">
        <el-icon><Delete/></el-icon>
        删除
      </el-button>
    </template>

    <template #table-column>
      <el-table-column prop="activityId" label="活动编号" align="center" width="200"></el-table-column>
      <el-table-column prop="activityName" label="活动名称" align="center" min-width="150"></el-table-column>
      <el-table-column prop="rewardType" label="奖励类型" align="center" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.rewardType === '1' ? 'warning' : 'success'">
            {{ scope.row.rewardType === '1' ? '积分' : '物品' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="pointsConfig" label="积分配置/物品" align="center" min-width="200">
        <template #default="scope">
          <span v-if="scope.row.rewardType === '1'">{{ scope.row.pointsConfig }}</span>
          <span v-else>{{ scope.row.itemId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="开始时间" align="center" width="170">
        <template #default="scope">{{ $formatTime(scope.row.startTime) }}</template>
      </el-table-column>
      <el-table-column prop="endTime" label="结束时间" align="center" width="170">
        <template #default="scope">{{ $formatTime(scope.row.endTime) }}</template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.status === '1' ? 'success' : 'info'">
            {{ scope.row.status === '1' ? '开启' : '关闭' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="170">
        <template #default="scope">{{ $formatTime(scope.row.createTime) }}</template>
      </el-table-column>
    </template>

    <template #extra>
      <el-dialog
        v-model="dialogVisible"
        :title="dialogType === 'add' ? '新增活动' : dialogType === 'edit' ? '修改活动' : '查看活动'"
        width="650px"
        destroy-on-close
      >
        <el-form
          ref="formRef"
          :model="formData"
          :rules="formRules"
          label-width="120px"
          class="list-modal-form"
          :disabled="dialogType === 'view'"
        >
          <el-form-item label="活动编号" v-if="dialogType !== 'add'">
            <el-input v-model="formData.activityId" disabled></el-input>
          </el-form-item>
          <el-form-item label="活动名称" prop="activityName">
            <el-input v-model="formData.activityName" placeholder="请输入活动名称" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="奖励类型" prop="rewardType">
            <el-radio-group v-model="formData.rewardType">
              <el-radio value="1">积分</el-radio>
              <el-radio value="2">物品</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="积分配置" prop="pointsConfig" v-if="formData.rewardType === '1'">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.pointsConfig"
              placeholder='JSON格式如 {"0":100,"1":150,"default":50}'
            ></el-input>
          </el-form-item>
          <el-form-item label="物品编号" prop="itemId" v-if="formData.rewardType === '2'">
            <el-select v-model="formData.itemId" placeholder="请选择物品" filterable style="width: 100%;">
              <el-option
                v-for="item in exchangeItems"
                :key="item.itemId"
                :label="item.itemName + ' (库存' + item.quantity + ')'"
                :value="item.itemId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="每辆可领数量" prop="itemCountPerCar" v-if="formData.rewardType === '2'">
            <el-input-number v-model="formData.itemCountPerCar" :min="1" style="width: 100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="开始时间" prop="startTime">
            <el-date-picker
              v-model="formData.startTime"
              type="datetime"
              placeholder="选择开始时间"
              value-format="YYYY-MM-DD HH:mm:ss"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker
              v-model="formData.endTime"
              type="datetime"
              placeholder="选择结束时间"
              value-format="YYYY-MM-DD HH:mm:ss"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="formData.status">
              <el-radio value="1">开启</el-radio>
              <el-radio value="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="2" v-model="formData.remark" placeholder="请输入备注" maxlength="500"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <div style="text-align: center; width: 100%;">
            <el-button @click="dialogVisible = false">{{ dialogType === 'view' ? '关闭' : '取消' }}</el-button>
            <el-button v-if="dialogType !== 'view'" type="primary" @click="handleSubmit">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </template>
  </CommonList>
</template>

<script setup>
import useWelfareActivityList from './WelfareActivityList.js';

const {
  searchForm,
  listRef,
  dialogVisible,
  dialogType,
  formRef,
  listShow,
  formData,
  formRules,
  exchangeItems,
  Plus,
  Edit,
  Delete,
  View,
  handleSelectionChange,
  handleCurrentRowChange,
  handleAdd,
  handleEdit,
  handleView,
  handleDelete,
  handleLoadList,
  handleReset,
  handleSubmit
} = useWelfareActivityList();
</script>

<style>
@import '../../../assets/css/util/base-list.css';
</style>
